import c from "./_baseGetTag.js";
import n from "./_getPrototype.js";
import a from "./isObjectLike.js";
var i = "[object Object]", f = Function.prototype, p = Object.prototype, e = f.toString, u = p.hasOwnProperty, b = e.call(Object);
function O(r) {
  if (!a(r) || c(r) != i)
    return !1;
  var o = n(r);
  if (o === null)
    return !0;
  var t = u.call(o, "constructor") && o.constructor;
  return typeof t == "function" && t instanceof t && e.call(t) == b;
}
export {
  O as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/isPlainObject.js
// module id = 1521
// module chunks = 41